import { ManagerInstructionsChat } from "./ManagerInstructionsChat";
import { useAuth } from "context/AuthContext";
import { useAssistantIdentity } from "hooks/useAssistantIdentity";
import { Bot } from "lucide-react";

export function ManagerInstructionsPanel() {
  const { impersonatedManager, lang } = useAuth();
  const locale = lang === "es" ? "es" : "en";
  const { assistantName } = useAssistantIdentity();
  const managerName = impersonatedManager?.contact.name?.trim() || "";

  return (
    <div className="flex h-full min-h-0 flex-1 flex-col gap-2 lg:gap-3 overflow-hidden">
      <div className="shrink-0 rounded-lg border border-red-200 bg-red-50 px-4 py-3">
        <div className="flex items-start gap-3">
          <Bot className="mt-0.5 h-5 w-5 shrink-0 text-red-600" aria-hidden />
          <div className="min-w-0">
            <h2 className="text-sm font-semibold text-red-900">
              {locale === "es"
                ? `Instrucciones a ${assistantName}`
                : `Instructions to ${assistantName}`}
            </h2>
            <p className="mt-1 text-xs text-red-800">
              {locale === "es"
                ? `Chateá con ${assistantName} como ${managerName || "el administrador"}. Usa el canal simulado: estos mensajes no aparecen en el historial del cliente.`
                : `Chat with ${assistantName} as ${managerName || "the property manager"}. Uses the simulated channel — hidden from the customer's normal history.`}
            </p>
          </div>
        </div>
      </div>
      <div className="flex min-h-0 min-w-0 w-full flex-1 flex-col overflow-hidden">
        <ManagerInstructionsChat />
      </div>
    </div>
  );
}
